<template>
  <article class="step" :style="stepElStyles">
    <div
      v-if="
        parentModule.config.general.showStepCounter ||
        parentModule.config.general.showProgressionLine
      "
      class="superline"
      :style="superlineElStyles"
    >
      <span
        v-if="parentModule.config.general.showStepCounter"
        class="superline-text"
      >
        {{ module.config.superline.text }}
      </span>

      <div
        v-if="parentModule.config.general.showProgressionLine"
        class="line"
      ></div>
    </div>
    <div
      v-if="showHeader(parentModule)"
      class="headline"
      :style="headerElStyles"
      v-html="module.config.header.text"
    ></div>
    <div
      class="text"
      :style="textElStyles"
      v-html="module.config.text.text"
    ></div>
  </article>
</template>

<script>
import stepModule from "./stepDefaultModuleProp.js";
import hiringProcessModule from "../HiringProcess/hiringProcessDefaultModuleProp.js";
import { globalMethods } from "../../GlobalUI/mixins/global.js";

export default {
  name: "Step",
  mixins: [globalMethods],
  props: {
    module: {
      type: Object,
      default() {
        return stepModule;
      },
    },
    parentModule: {
      type: Object,
      default() {
        return hiringProcessModule;
      },
    },
  },
  computed: {
    stepElStyles() {
      const { stepBackgroundColor, corners } = this.parentModule.config.general;

      const styles = {
        borderRadius:
          corners.value === "round" ? "var(--cr-border-radius-large)" : "0px",
        backgroundColor: stepBackgroundColor.value,
      };

      return styles;
    },
    headerElStyles() {
      const { isTextInCaps, textColor } = this.module.config.header;

      const styles = {
        textTransform: isTextInCaps ? "uppercase" : "initial",
        color: textColor.value,
        textAlign: this.parentModule.config.general.textAlign.value,
      };
      return styles;
    },
    textElStyles() {
      const { textColor } = this.module.config.text;

      const styles = {
        color: textColor.value,
        textAlign: this.parentModule.config.general.textAlign.value,
      };
      return styles;
    },
    superlineElStyles() {
      const { textColor } = this.module.config.superline;

      const styles = {
        color: textColor.value,
      };
      return styles;
    },
  },
};
</script>

<style lang="scss" scoped>
@include reset;

.step {
  --step-padding: 30px;

  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  padding: var(--step-padding);

  .-horizontal & {
    scroll-snap-align: start;
    width: 400px;
    min-height: 390px;

    @include mobile {
      width: calc(100cqw - var(--step-padding) * 2);
    }
  }

  ::marker {
    content: ""; //hides browser default arrow of summary
  }
}

.superline {
  display: flex;
  gap: var(--step-padding);
  padding-bottom: var(--step-padding);

  .line {
    position: relative;

    flex-grow: 1;
    align-self: center;

    height: 1px;

    background-color: currentcolor;

    &::after {
      content: "";

      position: absolute;
      top: -2px;
      right: 0;

      width: 5px;
      height: 5px;

      background-color: currentcolor;
      border-radius: 5px;
    }
  }
}

.superline-text {
  @include font-family("body");
}

.headline {
  @include font-family("heading");
  @include scale-fonts("heading-3");
  @include setup-richtext();

  hyphens: auto;
  padding-bottom: calc(var(--step-padding) / 2);
}

.text {
  padding-bottom: var(--step-padding);
  hyphens: auto;
  overflow-wrap: anywhere;

  @include font-family("body");
  @include scale-fonts("body");
  @include setup-richtext();
}
</style>
